module.exports = __webpack_public_path__ + "img/29.23d0ec19.png";